import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useRefreshMyStatus } from '../../hooks/queries/moodle/useRefreshMyStatus';

const BlockingBanner = ({ data }) => {
  const { mutate: refreshStatus, isPending } = useRefreshMyStatus();
  const courses = data?.blockingCourses ?? [];

  const blockingCourses = courses.filter(
    (c) => c.state !== 'EXCLUDED' && c.state !== 'COMPLETED',
  );

  return (
    <Dialog
      open={!!data?.blocked}
      disableEscapeKeyDown
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '100vw',
          height: '100vh',
          position: 'relative',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          backgroundImage: 'url(/assets/images/banner-image.png)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          px: 4,
          py: 6,
          textAlign: 'center',
        }}
      >
        <DialogTitle
          sx={{
            color: 'error.main',
            p: 0,
            mt: 2,
            fontSize: '2rem',
            fontWeight: 'bold',
          }}
        >
          Course Compliance — Access Blocked
        </DialogTitle>
        <Typography variant="h5" mb={2} sx={{ fontWeight: 'bold' }}>
          You have been blocked due to incomplete mandatory courses. Complete
          them to regain access.
        </Typography>
        <List
          dense
          disablePadding
          sx={{
            mb: 3,
            overflowY: 'auto',
            maxHeight: '50vh',
            width: '100%',
            px: 2,
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#bdbdbd',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#9e9e9e',
            },
          }}
        >
          {blockingCourses.map((course) => (
            <ListItem
              key={course.courseConfigId}
              disablePadding
              sx={{ justifyContent: 'center' }}
            >
              <ListItemText
                sx={{ textAlign: 'center' }}
                primary={
                  <strong
                    style={{
                      color: course.state === 'OVERDUE' ? '#d32f2f' : 'inherit',
                    }}
                  >
                    {course.courseName}
                  </strong>
                }
                secondary={
                  <Box component="span" sx={{ fontSize: '0.75rem' }}>
                    Deadline:{' '}
                    {course.deadlineAt
                      ? new Date(course.deadlineAt).toLocaleDateString()
                      : '—'}
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
        <Button
          variant="contained"
          color="error"
          size="large"
          sx={{ fontSize: '1.1rem', px: 4, py: 1 }}
          onClick={() => refreshStatus()}
          disabled={isPending}
          startIcon={
            isPending ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {isPending ? 'Refreshing...' : 'Refresh Status'}
        </Button>
      </Box>
    </Dialog>
  );
};

export default BlockingBanner;
